import React from 'react';
import {TextField} from "@mui/material";
import {useSelector} from "react-redux";

const Select = (props) => {

    const {users} = useSelector((state => state.main))

    const user_map = users.map(user => ({value: user.ID, label: `${user.NAME} ${user.LAST_NAME}`}))

    return (
        <TextField
            id="outlined-select-currency-native"
            select
            SelectProps={{
                native: true,
            }}
            variant="outlined"
            color={'secondary'}
            {...props}
        >
            <option selected={true} disabled={true} value=""></option>
            {user_map.map((option) => (
                <option key={option.value} value={option.value}>
                    {option.label}
                </option>
            ))}
        </TextField>
    );
};

export default Select;